import { render, staticRenderFns } from "./SliceLayerIcon.vue?vue&type=template&id=4968ef68&"
import script from "./SliceLayerIcon.vue?vue&type=script&lang=js&"
export * from "./SliceLayerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports